import { getAllOperationsMembers } from "app/services/distributorService";
import { useState } from "react";
import AsyncSelect from "react-select/async";

const OperationalUserAutoComplete = ({
  setState,
  name,
  selectedValue,
  setSelectedValue,
}) => {
  const [inputValue, setInputValue] = useState("");
  //   const [selectedValue, setSelectedValue] = useState(null);
  // Handle input change
  const handleInputChange = (value) => {
    setInputValue(value);
  };

  // Handle option selection
  const handleChange = (selectedOption) => {
    setSelectedValue(selectedOption);
    setState(selectedOption?.id || "");
  };

  // Load options from API
  const loadOptions = async (value) => {
    const inputValue = value.trim().toLowerCase();
    const { data } = await getAllOperationsMembers(inputValue);

    return (
      data?.data.map((item) => ({
        id: item.userId,
        label: `${item.username}`,
        // role: `${item.roleName}`,
      })) || []
    );
  };

  return (
    <AsyncSelect
      cacheOptions
      defaultOptions
      value={selectedValue}
      getOptionLabel={(e) => e.label}
      getOptionValue={(e) => e.id}
      loadOptions={loadOptions}
      onInputChange={handleInputChange}
      onChange={handleChange}
      name={name}
    />
  );
};

export default OperationalUserAutoComplete;
